// * Util functions

//  * Returns boolean
export const emptyStringObject = (user: { [key: string]: string }) =>
  Object.values(user).every((item) => item === '');

export const isAuthor = (role: string) => role === 'AUTHOR';
